import type { SidebarMenu } from './types';

/**
 * 설정 메뉴 라우팅 맵.
 */
export const sellerMap = {
  index: {
    title: '설정',
    path: '/settings',
    display: true,
  } satisfies SidebarMenu,
  'task-list': {
    title: '작업 목록',
    path: '/upload/task-list',
  } satisfies SidebarMenu,
  'create-mapping-group': {
    title: '새 맵핑 그룹 추가',
    path: '/category-setting/create/mapping-group',
    display: true,
  } satisfies SidebarMenu,
  'mapping-group': {
    title: '맵핑그룹 상세',
    path: '/category-setting/mapping-group',
  } satisfies SidebarMenu,
  'edit-mapping-group': {
    title: '맵핑그룹 수정',
    path: '/category-setting/edit/mapping-group',
    display: true,
  } satisfies SidebarMenu,
  'create-cafe24-category-setting': {
    title: '카페24 맵핑 추가',
    path: '/category-setting/create/cafe24-category-setting',
    display: true,
  } satisfies SidebarMenu,
  'brand-group': {
    title: '브랜드 설정',
    path: '/seller/brand/brand-group',
  } satisfies SidebarMenu,
  'sales-management-advanced': {
    title: '판매관리 설정',
    path: '/seller/sales-management-advanced',
    display: false,
  } satisfies SidebarMenu,
  'cafe24-auth': {
    title: '카페24 OAuth',
    path: '/auth/cafe24/redirect-handler',
  } satisfies SidebarMenu,
  'instagram-auth': {
    title: '인스타그램 OAuth',
    path: '/auth/instagram/redirect-handler',
  } satisfies SidebarMenu,
  'cafe24-store-auth': {
    title: '카페24 스토어 OAuth',
    path: '/auth/cafe24-store/redirect-handler',
  } satisfies SidebarMenu,
  dashboard: {
    title: '대시보드',
    path: '/dashboard',
    display: true,
  } satisfies SidebarMenu,
  'requirement-setting': {
    title: '기본 필수 설정',
    path: '/settings/market-linkage/cafe24/sync/requirement-setting',
  } satisfies SidebarMenu,
  template: {
    title: '엑셀 템플릿 관리',
    path: '/settings/template',
    display: true,
  } satisfies SidebarMenu,
} as const;
